import React, { useState } from "react";

import { Col, Row, Spinner, Table } from "react-bootstrap";

import { ListDocumentsQueryVariables, SortDirection, useListDocumentsQuery } from "@api/graphql";
import { FileDisplay } from "@components/grouped_resales/FileDisplay";
import { ReporterDisplay } from "@components/grouped_resales/ReporterDisplay";
import { UploadButton } from "@components/grouped_resales/UploadButton";

import { Pager } from "./Pager";

export const DocumentTable = () => {
  const [page, setPage] = useState(1);

  const queryVariables: ListDocumentsQueryVariables = {
    input: {
      page,
      limit: 25,
      filter_by: [],
      sort_by: { field: "date_created", direction: SortDirection.ASCENDING },
    },
  };

  const { data, loading, error } = useListDocumentsQuery({
    variables: queryVariables,
  });

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  const documents = data?.listDocuments.results || [];

  return (
    <>
      <Row className="mt-3">
        <Col>
          <Row>
            <Col>
              {loading && (
                <div className="w-100 d-flex justify-content-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              )}
              <Table cellSpacing={1}>
                <tbody>
                  {documents.map((doc) => {
                    return (
                      <>
                        <tr>
                          <td>
                            <ReporterDisplay reporter={doc.participant_name} company={doc.participant_company} />
                          </td>
                          <td>
                            <FileDisplay s3_location={doc.s3_location!} date_created={doc.date_modified} />
                          </td>
                          <td>
                            <UploadButton sourceRecord={doc} />
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <Row className="mt-3">
                <Col>
                  <Pager
                    page={page}
                    totalPages={data?.listDocuments.total_pages || 0}
                    totalItems={data?.listDocuments.total_items || 0}
                    setPage={setPage}
                  />{" "}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
